import { useCustomQuery } from './useCustomQuery';

interface Country {
  name: string;
  alpha3: string;
  emoji: string;
  alpha2: string;
  dialCode: string;
  region: string;
  capital: string | null;
  geo?: {
    lat: number;
    long: number;
  };
}

export function useCountries() {
  return useCustomQuery<Country[]>({
    queryKey: ['countries'],
    queryFn: async () => {
      const response = await fetch('/countries.json');
      if (!response.ok) {
        throw new Error('Failed to load countries');
      }
      return response.json();
    },
    staleTime: Infinity,
  });
}
